import { W2UiCmd } from "./w2const";
import W2UiFilter, { Edit, Search, Sort } from "./w2filter";

class W2UiFilterBuilder {
  public cmd?: string;
  public limit?: number;
  public offset?: number;
  public selected?: string;
  public searchLogic?: string;
  public search?: Search[];
  public sort?: Sort[];
  public edit?: Edit[];
  public del?: number[];

  setCmd(cmd: string) {
    this.cmd = cmd;
    return this;
  }

  setLimit(limit: number) {
    this.limit = limit;
    return this;
  }

  setOffset(offset: number) {
    this.offset = offset;
    return this;
  }

  setSelected(selected: string) {
    this.selected = selected;
    return this;
  }

  setSearchLogic(searchLogic: string) {
    this.searchLogic = searchLogic;
    return this;
  }

  setSearch(search: Search[]) {
    this.search = search;
    return this;
  }

  setEdit(...edit: Edit[]) {
    this.edit = edit;
    this.cmd=W2UiCmd.SAVE_RECORDS;
    return this;
  }

  setDelete(...del: number[]) {
    this.del = del;
    this.cmd=W2UiCmd.DELETE_RECORDS;
    return this;
  }

  addSearch(...search: Search[]) {
    this.search = [...(this.search || []), ...search];
    return this;
  }

  setSort(sort: Sort[]) {
    this.sort = sort;
    return this;
  }

  build() {
    return new W2UiFilter(
      this.cmd,
      this.limit,
      this.offset,
      this.selected,
      this.searchLogic,
      this.search,
      this.sort,
      this.edit,
      this.del
    );
  }
}

export default W2UiFilterBuilder;
